var React = require('react');

function LogoFooterInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M63.93 30.1793H63.9983V0H31.999V0.0690724C49.052 0.0690724 62.9842 13.3921 63.93 30.1793Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M63.9315 33.8208C62.9858 50.608 49.0536 63.931 32.0006 63.931V64.0001H63.9999V33.8208H63.9315Z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M31.9309 30.1793H31.9993V0H0V0.0690724C17.053 0.0690724 30.9852 13.3921 31.9309 30.1793Z","fill":"currentColor","key":2}),React.createElement("path",{"d":"M31.9309 33.8208C30.9852 50.608 17.053 63.931 0 63.931V64.0001H31.9993V33.8208H31.9309Z","fill":"currentColor","key":3})]);
}

LogoFooterInline.defaultProps = {"viewBox":"0 0 64 64","fill":"none"};

module.exports = LogoFooterInline;

LogoFooterInline.default = LogoFooterInline;
